import { SxProps, Theme } from '@mui/material'
import { Cell as TanstackCell, Header as TanstackHeader } from '@tanstack/react-table'
import React from 'react'

export type DataTableFilterVariant = 'text' | 'number' | 'select' | 'date'
export type DataTableComparisonFilterOperator =
  | 'after'
  | 'before'
  | 'between'
  | 'lessThan'
  | 'lessThanOrEqual'
  | 'moreThan'
  | 'moreThanOrEqual'

export interface DataTableComparisonFilterValue {
  end?: number | string
  operator: DataTableComparisonFilterOperator
  start?: number | string
  value?: number | string
}

export type DataTableFilterValue =
  | string
  | number
  | boolean
  | null
  | Array<string | number | boolean | null>
  | DataTableComparisonFilterValue

export const DATA_TABLE_NOT_NULL_FILTER_VALUE = '__DATA_TABLE_NOT_NULL__'
export const DATA_TABLE_NULL_FILTER_VALUE = '__DATA_TABLE_NULL__'

export interface DataTableFilterOption {
  label: string
  value: string | number | boolean | null
}

export interface DataTableActiveFilter {
  id: string
  label: string
  onDelete?: () => void
  value?: string
}

export interface DataTableColumnMeta<TData = unknown> {
  cellSx?: SxProps<Theme> | ((cell: TanstackCell<TData, unknown>) => SxProps<Theme>)
  columnLabel?: string
  enableFilter?: boolean
  enableNullFilter?: boolean
  exportable?: boolean
  filterMultiple?: boolean
  filterValue?: DataTableFilterValue
  filterValueLabel?: string
  onFilterChange?: (value: DataTableFilterValue | undefined) => void
  filterOptions?: DataTableFilterOption[]
  filterVariant?: DataTableFilterVariant
  group?: number
  headerSx?: SxProps<Theme> | ((header: TanstackHeader<TData, unknown>) => SxProps<Theme>)
  hideable?: boolean
}

export interface DataTableRowAction<TData> {
  icon: (row: TData) => React.ReactNode
  label: string
  onClick: (row: TData) => void
  testId?: string
}
